import {
  DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_BEGIN,
  DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_SUCCESS,
  DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_FAILURE,
  DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios'

export function getSupabaseExternalDb(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_BEGIN,
    });
    const { version, projectId, dbUuid } = args
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/supabase/externalDb/${dbUuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_SUCCESS,
            data: res.data.getdata,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}
export function dismissGetSupabaseExternalDbError() {
  return {
    type: DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_BEGIN:
      return {
        ...state,
        getSupabaseExternalDbPending: true,
        getSupabaseExternalDbError: null,
      };

    case DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_SUCCESS:
      return {
        ...state,
        getSupabaseExternalDbPending: false,
        getSupabaseExternalDbError: null,
        supabaseStoredData: action.data,
      };

    case DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_FAILURE:
      return {
        ...state,
        getSupabaseExternalDbPending: false,
        getSupabaseExternalDbError: action.data.error,
      };

    case DATA_CONNECTOR_GET_SUPABASE_EXTERNAL_DB_DISMISS_ERROR:
      return {
        ...state,
        getSupabaseExternalDbError: null,
      };

    default:
      return state;
  }
}
